import React, { useState, useEffect } from "react";
import api from "./api";
import useAuth from "../hooks/useAuth";
import "./Doctors.css"; // optional, for compact card styling

const Callleads = () => {
  const { auth } = useAuth();
  const [callleads, setCallleads] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const [isWhatsappModalOpen, setIsWhatsappModalOpen] = useState(false);
  const [relation, setRelation] = useState("self");
  const [selectedHistory, setSelectedHistory] = useState([]);
  const [sameContactChecked, setSameContactChecked] = useState(false);

  const cardButtonStyle = {
  padding: "5px 7px",
  border: "none",
  borderRadius: 4,
  cursor: "pointer",
  color: "#fff",
  fontWeight: "bold",
    fontSize: '18px',
    width: 'auto !important'
};

  const ailmentOptions = [
    'Cervical' ,
    'UpperBack' ,
     'Shoulder' ,
    'Arm' ,
    'Wrist' ,
    'Chest' ,
    'MiddleBack' ,
    'LowerBack' ,
    'Coccyx' ,
    'Thigh' ,
    'Knee' ,
    'Calf' ,
    'Leg' ,
     'Ankle' ,
    'Foot' ,
    'Lung' ,
    'Heart' ,
    'Abdomen' ,
     'Digestive' ,
     'Reproductive' ,
    'Renal' ,
    'Courses',
    'ReRoot Products',
    'Other' ,
  
];
  // --- Local temporary lead object ---
const emptyLead = {
  name: "",
  number: 0,
  branch: auth.branch || 'MedicalYogaTherapyCentre',
  address: "",
  sameContactChecked: false,
  relationship: "self",
  enquiredForName: "",
  enquiredForAge: "",
  messageText: "",
  selectedTemplate: "",
  enquiredForGender: "",
  enquiredForNumber: 0,
  preferredContact: "phone",
  email: "",
  enquirySource: "internet",
  enquiryDate: new Date().toISOString().split("T")[0],
  followUpDate: "",
  enquiryDetails: "",
  comments: "",
  status: "enquiry",
  weight: "",
  bp: "",
  height: "",
  o2: "",
};

  const [formData, setFormData] = useState(emptyLead);

  useEffect(() => {
    fetchLeads();
  }, []);

  const fetchLeads = async () => {
    try {
      const res = await api.get(`${process.env.REACT_APP_URL}/callleads/profiles?t=${Date.now()}`);
      setCallleads(res.data || []);
    } catch (err) {
      console.error("Error fetching leads", err);
    }
  };

  const handleChange = (value) => {
  setLeaveForWhom(value);
};

  // --- Smart follow-up date calculation ---
  const getNextFollowUpDateTime = () => {
    const today = new Date();
    const fallback = new Date(today);
    fallback.setDate(today.getDate() + 4);

    const nextWeekend = new Date(today);
    while (nextWeekend.getDay() !== 6 && nextWeekend.getDay() !== 0) {
      nextWeekend.setDate(nextWeekend.getDate() + 1);
    }

    const chosen = nextWeekend < fallback ? nextWeekend : fallback;
    const isWeekend = [0, 6].includes(chosen.getDay());
    chosen.setHours(isWeekend ? 17 : 11, 0, 0, 0);
    return chosen;
  };

  // --- Lead Scoring Logic (simple example) ---
  const calculateLeadScore = (lead) => {
    let score = 0;
    if (lead.number) score += 20;
    if (lead.email) score += 10;
    if (lead.enquiryDetails?.length > 20) score += 15;
    if (lead.followUpDate) score += 10;
    if (["followup"].includes(lead.status)) score += 15;
    if (lead.status === "registered") score += 30;
    return Math.min(score, 100);
  };
const openWhatsAppChat = (lead) => {
  if (!lead.number || !lead.name)
    return alert("No name or phone number available.");
  openWhatsappModal("newmsg", lead);
};

const openWhatsappModal = (selectedTemplate, lead) => {
  console.log("openWhatsappModal", lead);
  setSelectedLead(lead); // ✅ Store lead
  setFormData((p) => ({ ...p, selectedTemplate })); // preselect
  setIsWhatsappModalOpen(true);
};

const handleSendWhatsApp = async () => {
  if (!selectedLead) return alert("No lead selected.");
  if (!formData.messageText?.trim())
    return alert("Please type or select a message to send.");

  var finalMsg = `Namaste ${selectedLead.name} Ji ! ${formData.messageText?.trim()}`;
  formData.messageText = finalMsg; 
  const phone = String(selectedLead.number).replace(/\D/g, "");
  const encodedMessage = encodeURIComponent(formData.messageText.trim());
  const whatsappUrl = `https://wa.me/91${phone}?text=${encodedMessage}`;

  // ✅ Open WhatsApp window
  window.open(whatsappUrl, "_blank");

  const confirmed = window.confirm(
    `Did you successfully send this message to ${selectedLead.name}?`
  );
  if (!confirmed) return;

  try {
    const now = new Date();
    const newFollowUp = new Date();
    newFollowUp.setDate(now.getDate() + Number(selectedLead.followUpFrequency || 7));

    const newMessageEntry = {
      date: now.toISOString(),
      type: formData.selectedTemplate || "custom",
      text: formData.messageText,
    };

    const updateData = {
      lastMessageType: formData.selectedTemplate || "custom",
      lastMessageDate: now.toISOString(),
      followUpDate: newFollowUp.toISOString(),
      status: formData.status || "followup",
      messageHistory: [...(selectedLead.messageHistory || []), newMessageEntry],
    };

    await api.post(
      `${process.env.REACT_APP_URL}/callleads/profiles/update/${selectedLead._id}`,
      updateData
    );

    fetchLeads();
    /*
    // update local state
    setCallleads((prev) =>
      prev.map((l) =>
        l._id === selectedLead._id ? { ...l, ...updateData } : l
      )
    ); */

    alert("✅ Message sent and recorded!");
    setIsWhatsappModalOpen(false);
  } catch (err) {
    console.error("Error updating WhatsApp history:", err);
    alert("❌ Failed to save message to history.");
  }
};


  const openWhatsAppCall = (number) => {
    if (!number) return alert("No phone number available.");
    const formatted = String(number).replace(/\D/g, "");
    window.open(`tel:${formatted}`, "_self"); // triggers phone call if supported
  };

  // --- Add Lead ---
  const handleAddLead = async (e) => {      
    e.preventDefault();

    if (!formData.ailments || formData.ailments?.length == 0)
    {
      alert("Please select atleast 1 enquiry Type");
      return;
    }
    try {
      const nextFollowup = formData.followUpDate
        ? new Date(formData.followUpDate)
        : getNextFollowUpDateTime();

      const payload = {
        ...formData,
        followUpDate: nextFollowup.toISOString(),
        score: calculateLeadScore(formData),
        status: "enquiry"
      };

      if (payload.relationship == "self")
      {
        payload.enquiredForName = payload.name;
        payload.enquiredForNumber = payload.number;
      }
      const res = await api.post(
        `${process.env.REACT_APP_URL}/callleads/profiles/add`,
        payload
      );
      setCallleads((prev) => [...prev, res.data]);
      alert("Lead added successfully!");
      handleClose();
    } catch (err) {
      console.error("Error adding lead", err);
      alert("Failed to add lead.");
    }
  };

  // --- Update Lead ---
  const handleUpdateLead = async (e) => {
    e.preventDefault();
    if (!selectedLead?._id) return alert("No lead selected.");
    if (!formData.followUpDate) return alert("Add Follow-up Date.");

    try {
      const payload = {
        ...formData,
        score: calculateLeadScore(formData),
        status: formData.status || "followup",
      };
      await api.post(
        `${process.env.REACT_APP_URL}/callleads/profiles/update/${selectedLead._id}`,
        payload
      );

      setCallleads((prev) =>
        prev.map((cl) =>
          cl._id === selectedLead._id ? { ...payload, _id: cl._id } : cl
        )
      );
      alert("Lead updated successfully!");
      handleClose();
    } catch (err) {
      console.error("Error updating lead", err);
      alert("Failed to update lead.");
    }
  };

  // --- Delete Lead ---
  const handleDeleteLead = async (id) => {
    if (!window.confirm("Are you sure you want to delete this lead?")) return;

    try {
      await api.delete(`${process.env.REACT_APP_URL}/callleads/profiles/delete/${id}`);
      setCallleads((prev) => prev.filter((cl) => cl._id !== id));
      alert("Lead deleted successfully!");
    } catch (err) {
      console.error("Error deleting lead", err);
      alert("Failed to delete lead.");
    }
  };

  const handleInputChange = (field, value) => {
  setFormData(prev => ({
    ...prev,
    [field]: value,
  }));
};

  const openHistoryModal = (lead) => {
  //setSelectedHistory(lead.history || []);
  setSelectedLead(lead);
  setIsHistoryModalOpen(true);
};

const closeHistoryModal = () => {
  setIsHistoryModalOpen(false);
  setSelectedLead(null);
  //setSelectedHistory([]);
};



const closeWhatsappModal = () => {
  setIsWhatsappModalOpen(false);
  
};

  // --- Search / Filter / Pagination ---
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const leadsPerPage = 70;
  const whatsappTemplates = [
    { id: "newmsg", label: "New Message", text: "" },
    { id: "welcome", label: "Welcome Message", text: "welcome to our therapy program! We're here to help you recover and feel better soon. 🌿" },
    { id: "followup", label: "Follow-up Reminder", text: "just checking in! How are you feeling since our last session?" },
    { id: "feedback", label: "Feedback Request", text: "we value your feedback. Could you please share your experience with us?" },
    { id: "lowerbackpain1", label: "Lower Back Pain - Small Movements", text:"\n Small Movements, Big Protection Studies show that lumbar disc pressure rises by up to 40% when sitting for long hours. Just standing or walking for 2 minutes every 30–40 minutes improves blood flow to spinal tissues and reduces stiffness by over 60%. Your spine doesn’t need long workouts — it simply needs regular breaks from stillness.\
    \n🩺 From the DS 3-Phase Method of Permanent Recovery™ — blending medical precision with advanced biomechanics for measurable results. Ancient Wisdom. Future Tech. Healing Now."},
    { id: "lowerbackpain2", label: "Lower Back Pain - Hydration", text: "\n Hydration is Hidden Medicine Spinal discs are made of nearly 85% water. Even mild dehydration can reduce their cushioning capacity and increase nerve friction. Sipping warm water steadily through the day (not in large gulps) keeps discs hydrated, supple, and pain-free. Every sip supports spinal healing from within.\
    \n🩺 From the DS 3-Phase Method of Permanent Recovery™ — blending medical precision with advanced biomechanics for measurable results. Ancient Wisdom. Future Tech. Healing Now." },
    {id: "lowerbackpain3", label: "Lower Back Pain - 3-Minute Reset", text: "\n The 3-Minute Reset Before Sleep Research shows that people with chronic back pain hold 15–30% more muscle tension even during rest. Before sleep, lie flat, breathe slowly, and consciously relax your lower back and hips for 3 minutes. This simple nightly reset reduces neural tension and promotes natural recovery overnight.\
    \n🩺 From the DS 3-Phase Method of Permanent Recovery™ — blending medical precision with advanced biomechanics for measurable results. Ancient Wisdom. Future Tech. Healing Now."},
   {id: "lowerbackpain4", label: "Lower Back Pain - At MYC", text: "\n At our centre, we don’t suppress pain; we decode it  and  resolve it from the root.\
    \nThe DS 3-Phase Method of permanent recovery™ blends medical precisio with advance Bio-mechanics based therapeutic healing, teaching the body to trust movement again.\
    \nBecause permanent healing begins when awareness meets alignment and science. 🩺 From the DS 3-Phase Method of Permanent Recovery™ — Blending Medical Precision with Advanced Biomechanics for Measurable Results.\
    \nAncient Wisdom. Future Tech. Healing Now. "},
  {id: "lowerbackpain5", label: "Lower Back Pain - In sciatica cases", text: "\n In most sciatica cases, pain isn’t from the disc alone — it's from nerve compression, pelvic misalignment, muscular stiffness, tight ligaments and some other associated factors as well.\
    \nUsing our DS 3-Phase method of permanent recovery™, we restore natural mobility between the vertebrae and nerve pathway. \
    \n87% of patients experience visible pain relief within 10 sessions. \
    \nTrue healing begins when the spine moves with intelligence, not effort. 🌿 \
    \n 🩺 From the DS 3-Phase Method of Permanent Recovery™ — Blending Medical Precision with Advanced Biomechanics for Measurable Results.\
    \nAncient Wisdom. Future Tech. Healing Now. "},
  {id: "lowerbackpain6", label: "Lower Back Pain - Permanent Recovery Protocol", text: "\n Our 3-Phase Permanent Recovery Protocol™ is so precise and individualized that it has helped over 50,000 individuals regain pain-free movement — and thousands have avoided surgeries at our centre over the past 22 years. All of this has been achieved without medicines, without physiotherapy machines — only through our structured 3-Phase DS Method™: Dissolve Suffering · Develop Strength · Decisive Sustainability\
  Listen to Rishabh’s story — once 100% bedridden for months, he is now back on the field, playing cricket and organizing tournaments."},
  {id: "lowerbackpain7", label: "Lower Back Pain - Rishabh’s Story", text: "🌿Rishabh’s Story — From Pain to Performance \
    “I couldn’t get out of bed for months. Then I discovered the DS 3-Phase Method of permanent recovery™ at Dr. Deepak Sachdeva’s Therapy Centre. Today, I’m not only pain-free but back to playing and organising cricket tournaments again.” — Rishabh, CEO of a reputed transport company. \
    At our centre, we don’t just reduce pain — we decode it, resolve it, and restore movement from the root. Our 3-Phase Method of Permanent Recovery™ blends medical precision with advanced biomechanics-based therapeutic healing, teaching the body to trust movement again. Because permanent healing begins when awareness meets alignment and science. \
    \n🎥 Watch Rishabh’s candid, real-life journey: https://www.youtube.com/watch?v=htyzNmYPoVo \
    \n🩺 From the DS 3-Phase Method of Permanent Recovery™ — Blending Medical Precision with Advanced Biomechanics for Measurable Results.\
    Ancient Wisdom. Future Tech. Healing Now. "},
  {id: "neckpain1", label: "Neck Pain - Screen Angle", text: "Screen Angle Defines Neck Health \
  \nStudies show that tilting the head just 30° forward while looking down at a phone increases neck load from 5 kg to nearly 18 kg. Keep your screen at eye level — whether sitting, standing, or working on a laptop. This single correction reduces strain on the cervical discs and prevents long-term degeneration. \
  \n🩺 From the DS 3-Phase Method of Permanent Recovery™ — blending medical precision with advanced biomechanics for measurable results. Ancient Wisdom. Future Tech. Healing Now. "},

    {id: "neckpain2", label: "Neck Pain - Micro Movement", text: "Micro-Movement Rehydrates Cervical Discs \
    \nHolding the neck still for long durations causes the discs to lose hydration and elasticity. Every 45 minutes, perform gentle chin tucks and shoulder rolls within a pain-free range. These micro-movements restore joint lubrication and reduce pressure on nerves by up to 20%. Consistency prevents stiffness from becoming structural.\
    \n🩺 From the DS 3-Phase Method of Permanent Recovery™ — blending medical precision with advanced biomechanics for measurable results. Ancient Wisdom. Future Tech. Healing Now. "},

    {id: "neckpain3", label: "Neck Pain - The Sleep Support Equation", text: "The Sleep Support Equation\
    \nForce-distribution studies confirm that a low, firm pillow aligned with the neck’s curve maintains neutral cervical posture through the night. Avoid stacking pillows or sleeping on your stomach — both twist the spine and strain neck muscles. A single well-fitted pillow reduces morning stiffness by over 50%. \
    \n🩺 From the DS 3-Phase Method of Permanent Recovery™ — blending medical precision with advanced biomechanics for measurable results. Ancient Wisdom. Future Tech. Healing Now. "},

    {id: "kneepain1", label: "Knee Pain - The Quadriceps Connection", text: "The Quadriceps Connection\
  \nResearch shows that weak quadriceps increase joint load on the knee by up to 45%. Simple, controlled strength work — like seated leg raises or slow wall-supported squats (within a pain-free range) — helps absorb shock and protect the joint surface. Strength, not rest, restores knee stability.\
  \n🩺 From the DS 3-Phase Method of Permanent Recovery™ — blending medical precision with advanced biomechanics for measurable results. Ancient Wisdom. Future Tech. Healing Now."},

    {id: "kneepain2", label: "Knee Pain - The Weight–Pressure", text: "The Weight–Pressure Equation\
\nBiomechanical data shows that every extra kilogram of body weight adds nearly 4 kilograms of pressure on each knee with every step. Even a modest 2–3 kg weight reduction can lower joint stress and inflammation by 10–12%. Joint recovery begins when load and alignment are both managed intelligently.\
\n🩺 From the DS 3-Phase Method of Permanent Recovery™ — blending medical precision with advanced biomechanics for measurable results. Ancient Wisdom. Future Tech. Healing Now."},

    {id: "kneepain3", label: "Knee Pain - Alignment Before Exercise", text: "Alignment Before Exercise\
Most knee pain isn’t from the knee itself — it’s from hip and ankle misalignment. 3D motion studies confirm that correcting pelvic and foot angles reduces abnormal knee strain by up to 30%. Always ensure your leg axis (hip–knee–ankle) stays straight during any exercise or walking routine. Alignment protects more than effort heals.\
🩺 From the DS 3-Phase Method of Permanent Recovery™ — blending medical precision with advanced biomechanics for measurable results. Ancient Wisdom. Future Tech. Healing Now."},




    { id: "", label: "", text: ""},
  ];

  const filteredLeads = callleads.filter((lead) => {
    const term = searchTerm.toLowerCase();
    const matchesSearch =
      lead.name?.toLowerCase().includes(term) ||
      lead.number?.toString().includes(term) ||
      lead.status?.toLowerCase().includes(term);
    const matchesStatus =
      statusFilter === "all" || lead.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const totalPages = Math.ceil(filteredLeads.length / leadsPerPage);
  const paginatedLeads = filteredLeads.slice(
    (currentPage - 1) * leadsPerPage,
    currentPage * leadsPerPage
  );

  // --- Modal control ---
  const openAddModal = () => {
    setFormData(emptyLead);
    setIsEditMode(false);
    setIsModalOpen(true);
  };
  const openEditModal = (lead, type) => {
    setSelectedLead(lead);
    setFormData(lead);
    if (type == "personal")
    {
      setIsEditMode(false);
      setIsModalOpen(true);
    }
    else
    {
      setIsEditMode(true);
      setIsModalOpen(false);
    }
  };
  const handleClose = () => {
    setIsModalOpen(false);
    setIsEditMode(false);
    setFormData(emptyLead);
    setSelectedLead(null);
    fetchLeads();
  };

  // --- JSX ---
  return (
    <div style={{ padding: "20px" }}>
      {/* Header / Controls */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
          flexWrap: "wrap",
          gap: 10,
        }}
      >
        <button
          onClick={openAddModal}
          style={{
            padding: "8px 18px",
            background: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          + Add Lead
        </button>

        <input
          type="text"
          placeholder="Search by name, number or status..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            flex: "1 1 250px",
            padding: "8px",
            borderRadius: 4,
            border: "1px solid #ccc",
          }}
        />

        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          style={{
            padding: "8px",
            borderRadius: 4,
            border: "1px solid #ccc",
            background: "#fff",
          }}
        >
          <option value="all">All Statuses</option>
          <option value="onhold">On Hold</option>
          <option value="register">Registered</option>
          <option value="lost">Lost</option>
        </select>
      </div>

      {/* Lead Cards Grid */}
     <div style={{ marginTop: 25 }}>
  {/* 🔔 Legend */}
  <div
    style={{
      marginBottom: 12,
      fontSize: 14,
      color: "#555",
      display: "flex",
      alignItems: "center",
      gap: 8,
    }}
  >
    <span
      style={{
        display: "inline-block",
        width: 12,
        height: 12,
        background: "#ff9800",
        borderRadius: "50%",
      }}
    ></span>
    🔔 <span style={{ fontWeight: "500" }}>Follow-up required today or tomorrow</span>
  </div>

  {/* 🔲 Cards grid */}
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
      gap: 20,
    }}
  >
  {paginatedLeads.map((lead) => {
  const followUpDate = lead.followUpDate ? new Date(lead.followUpDate) : null;
  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);
  const followUpRequired = followUpDate && followUpDate <= tomorrow;

  return (
    <div
      key={lead._id}
      style={{
        background: "#fff",
        border: followUpRequired ? "2px solid #ff9800" : "1px solid #ddd",
        borderRadius: 8,
        padding: 15,
        boxShadow: followUpRequired
          ? "0 2px 10px rgba(255,152,0,0.4)"
          : "0 2px 5px rgba(0,0,0,0.1)",
        position: "relative",
        display: "grid",
        gridTemplateRows: "auto auto auto",
        gap: 6,
      }}
    >
      {followUpRequired && (
        <div
          style={{
            position: "absolute",
            top: -8,
            right: 8,
            background: "#ff9800",
            color: "white",
            fontSize: 12,
            padding: "2px 8px",
            borderRadius: 4,
            fontWeight: "bold",
          }}
        >
          🔔 Follow-up Required
        </div>
      )}

  <div>
    <div
      onClick={() => openEditModal(lead, "personal")}
      style={{
        cursor: "pointer",
        color: "#000",
      }}
      title="Click to edit this lead"
    >
    <strong style={{ textDecoration: "underline", color: "#007bff" }}>
      {lead.name}
    </strong>{" "}
      ({lead.relationship} / {lead.number})
    <br />
    <small>
        Created: {lead.enquiryDate
          ? new Date(lead.enquiryDate).toLocaleDateString("en-GB").replace(/\//g, "-")
          : "—"}{" "}
        / {lead.status?.toUpperCase()}
    </small>
  <br />
  </div>
    <br />
    {lead.followUpDate && (
      <small style={{ color: followUpRequired ? "#ff9800" : "#555", fontWeight: '700', fontSize: '14px' }}>
        Follow-up: {new Date(lead.followUpDate).toLocaleString([], { 
          day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" 
        })}
      </small>
    )}
    <br />

  {(lead.followUpHistory?.length > 0 || lead.messageHistory?.length > 0) && (
    <>
  <small
    onClick={() => openHistoryModal(lead)}
    style={{
      color: "#007bff",
      fontSize: "15px",
      cursor: "pointer",
      textDecoration: "underline",
      fontWeight: "500",
    }}
    title="Click to view full follow-up history"
  >
    🔁 Follow-ups: {lead.followUpHistory.length}
  </small>

    <small
    onClick={() => openHistoryModal(lead)}
    style={{
      color: "#007bff",
      fontSize: "15px",
      cursor: "pointer",
      textDecoration: "underline",
      fontWeight: "500",
    }}
    title="Click to view full follow-up history"
  >
    🔁 WhstappMsgs: {lead.messageHistory.length}
  </small>
  </>
)}

  </div>

      {/* --- Action Buttons --- */}
      <div style={{ marginTop: 8, display: "flex", gap: 8, flexWrap: "wrap" }}>
        <button
          onClick={() => openEditModal(lead, "followup")}
          style={cardButtonStyle}
        >
          ✏️ 
        </button>

        <button
          onClick={() => handleDeleteLead(lead._id)}
          style={{ ...cardButtonStyle, background: "#f44336" }}
        >
          🗑️ 
        </button>

        <button
          onClick={() => openWhatsAppChat(lead)}
          style={{ ...cardButtonStyle, background: "#25D366" }}
        >
          💬 
        </button>

        <button
          onClick={() => openWhatsAppCall(lead.number)}
          style={{ ...cardButtonStyle, background: "#007bff" }}
        >
          📞 
        </button>
      </div>
    </div>
  );
})}

  </div>
</div>


      {/* Pagination */}
      <div
        style={{
          marginTop: 20,
          display: "flex",
          justifyContent: "center",
          gap: 10,
          alignItems: "center",
        }}
      >
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => p - 1)}
        >
          ⬅ Prev
        </button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((p) => p + 1)}
        >
          Next ➡
        </button>
      </div>
            
      {/* --- Add Modal Popup --- */}
      {isModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) handleClose();
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: 25,
              borderRadius: 10,
              width: "90%",
              maxWidth: '70vw',
              boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
              animation: "fadeIn 0.3s ease-in-out",
              margin: '10px',
              height: '87vh',
              overflow: 'auto',
            }}
          >
            <h3 style={{ textAlign: "center", marginBottom: 15 }}>
              {isEditMode ? "Edit Lead" : "Add New Lead"}
            </h3>

            <form
              onSubmit={isEditMode ? handleUpdateLead : handleAddLead}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "12px 18px",
                overflow: 'auto'
              }}
            >
              {/* Row 1 */}
              <div>
                <label>Enquirer's Name:</label>
                <input
                  type="text"
                  value={formData.name || ""}
                  onChange={(e) =>
                    setFormData((p) => ({ ...p, name: e.target.value }))
                  }
                  required
                  style={inputStyle}
                />
              </div>

              <div>
                <label>Phone:</label>
                <input
                  type="number"
                  value={formData.number || ""}
                  onChange={(e) => {
                    const onlyNums = e.target.value.replace(/[^\d]/g, "").slice(0, 10);
                    setFormData((p) => ({ ...p, number: onlyNums }));
                  }}
                  pattern="[0-9]{10}"
                  required
                  placeholder="10-digit mobile"
                  style={inputStyle}
                />
              </div>


                <div className="ele">
                  <label>Address: </label>
                  <input
                    type="text"
                    value={formData.address || ""}
                    onChange={(e) => handleInputChange("address", e.target.value)}
              
                    style={inputStyle}
                  />
                </div>
              

                <div className="ele">
                  <label>Relationship to Enquired Person: </label>
                  <select
                    value={formData.relationship || "self"}
                    onChange={(e) => {
                      handleInputChange("relationship", e.target.value);
                      setRelation(e.target.value);
                    }}
                    style={inputStyle}
                  >
                    <option value="selectR">Select Relation</option> 
                    <option value="self">Self</option>
                    <option value="father">Father</option>
                    <option value="mother">Mother</option>
                    <option value="sibling">Sibling</option>
                    <option value="spouse">Spouse</option>
                    <option value="relative">Relative</option>
                    <option value="friend">Friend</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                {/* Enquired For (Person) Details */}{/* Enquired For Name */}

                {(relation != "self") && 
                (
                  <>
                  <div className="ele">
                    <label>Enquired For - Name: </label>
                    <input
                      type="text"
                      value={formData.enquiredForName || ""}
                      onChange={(e) => handleInputChange("enquiredForName", e.target.value)}
                      style={{ width: "100%", padding: 6, borderRadius: 4, border: "1px solid #ccc" }}
                      disabled={formData.relationship === 'self'}
                    />
                  </div>
      
                  <div className="ele">
                    <label>Enquired For - Age: </label>
                    <input
                      type="number"
                      min="0"
                      value={formData.enquiredForAge || ""}
                      onChange={(e) => handleInputChange("enquiredForAge", e.target.value)}
                      style={{ width: "100%", padding: 6, borderRadius: 4, border: "1px solid #ccc" }}
                    />
                  </div>
              
                  <div className="ele">
                    <label>Enquired For - Gender: </label>
                    <select
                      value={formData.enquiredForGender || ""}
                      onChange={(e) => handleInputChange("enquiredForGender", e.target.value)}
                      style={{ width: "100%", padding: 6, borderRadius: 4, border: "1px solid #ccc" }}
                    >
                      <option value="">Select</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </select>
                  </div>

                <div className="ele" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <label>Enquired For - Contact Number: </label>
                  <input
                    type="text"
                    value={formData.enquiredForNumber || ""}
                    onChange={(e) => handleInputChange("enquiredForNumber", e.target.value)}
                    disabled={sameContactChecked}
                  
                    style={inputStyle}
                  />
                  <label style={{ whiteSpace: 'nowrap' }}>
                    <input
                      type="checkbox"
                      style={{height:31}}
                      checked={sameContactChecked}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setSameContactChecked(isChecked);
                        handleInputChange(
                          "enquiredForNumber",
                          isChecked ? formData.number || "" : ""
                        );
                      }}
                    />{" "}
                    Same
                  </label>
                </div>
                </>
              )}

              {/* Preferred Contact */}
              <div className="ele">
                <label>Preferred Contact Method: </label>
                <select
                  value={formData.preferredContact || "phone"}
                  onChange={(e) => handleInputChange("preferredContact", e.target.value)}
                  style={inputStyle}
                >
                  <option value="phone">Phone</option>
                  <option value="email">Email</option>
                  <option value="whatsapp">WhatsApp</option>
                </select>
              </div>

            <div className="ele">
                <label>Email: </label>
                <input
                  type="email"
                  value={formData.email || ""}
                  onChange={(e) => handleInputChange("email", e.target.value)}
                  style={inputStyle}
                />
              </div>

              {/* Enquiry Source */}
              <div className="ele">
                <label>Enquiry Source: </label>
                <select
                  value={formData.enquirySource || "knownperson"}
                  onChange={(e) => handleInputChange("enquirySource", e.target.value)}
                  style={inputStyle}
                >
                  <option value="internet">Internet/WebSite</option>
                  <option value="knownperson">Friend/Relative</option>
                  <option value="social">Facebook/Insta/</option>
                </select>
              </div>

              {/* Row 2 */}
              <div>
                <label>Status:</label>
                <select
                  value={formData.status}
                  onChange={(e) =>
                    setFormData((p) => ({ ...p, status: e.target.value }))
                  }
                  style={inputStyle}
                >
                  <option value="onhold">On Hold</option>
                  <option value="registered">Registered</option>
                  <option value="lost">Lost</option>
                </select>
              </div>

              {/* Enquiry Type (Ailments) */}
              <div style={{ gridColumn: "1 / span 2" }}>
                <label>Enquiry Type (Ailments):</label>
                <div style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  padding: "8px"
                }}>
                  {ailmentOptions.map(opt => (
                    <label key={opt} style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                      <input
                        type="checkbox"
                        checked={formData.ailments?.includes(opt) || false}
                        onChange={(e) => {
                          const selected = formData.ailments || [];
                          if (e.target.checked) {
                            setFormData(p => ({ ...p, ailments: [...selected, opt] }));
                          } else {
                            setFormData(p => ({ ...p, ailments: selected.filter(a => a !== opt) }));
                          }
                        }}
                      />
                      {opt}
                    </label>
                  ))}
                </div>
              </div>

              {/* Row 3 */}
                <div style={{ gridColumn: "1 / span 2" }}>
                          <label>Other / Enquiry Details by Caller </label>
                          <textarea
                            rows={2}
                            placeholder="Write Caller's queries here"
                         
                            value={formData.enquiryDetails || ""}
                            onChange={(e) =>
                              setFormData((p) => ({ ...p, enquiryDetails: e.target.value }))
                            }
                            required   // 🔑 Add this
                            style={{
                              ...inputStyleT,
                              resize: "vertical",
                              minHeight: "60px",
                              width: '45vw !important'
                            }}
                          />
                        </div>

              <div style={{ gridColumn: "1 / span 2" }}>
                <label>FollowUp Comments By MYC </label>
                <textarea
                  rows={2}
                  value={formData.comments || ""}
                  placeholder="Answers to Caller's queries here"
                         
                  onChange={(e) =>
                    setFormData((p) => ({ ...p, comments: e.target.value }))
                  }
                  
                  style={{
                    ...inputStyleT,
                    resize: "vertical",
                    minHeight: "60px",
                    width: '45vw !important'
                  }}
                />
              </div>


              <div>
                <label>Follow-up Date:</label>
                <input
                  type="datetime-local"
                  value={
                    formData.followUpDate
                      ? new Date(formData.followUpDate).toISOString().slice(0, 16)
                      : ""
                  }
                  onChange={(e) =>
                    setFormData((p) => ({ ...p, followUpDate: e.target.value }))
                  }
                  style={inputStyle}
                />
              </div>

        
              {!isEditMode && (
                <div>
                  <label>Whatsapp Frequency (days):</label>
                  <select
                    value={formData.followUpFrequency || "7"}
                    onChange={(e) =>
                      setFormData((p) => ({ ...p, followUpFrequency: e.target.value }))
                    }
                    style={inputStyle}
                  >
                    <option value="5">5 days</option>
                    <option value="7">7 days</option>
                    <option value="10">10 days</option>
                  </select>
                </div>
              )} 

              {/* Buttons */}
              <div
                style={{
                  gridColumn: "1 / span 2",
                  display: "flex",
                  justifyContent: "center",
                  gap: 10,
                  marginTop: 8,
                }}
              >
                <button
                  type="submit"
                  style={{
                    background: "#007bff",
                    color: "white",
                    padding: "8px 18px",
                    border: "none",
                    borderRadius: 5,
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  {isEditMode ? "Update Lead" : "Add Lead"}
                </button>
                <button
                  type="button"
                  onClick={handleClose}
                  style={{
                    background: "#6c757d",
                    color: "white",
                    padding: "8px 18px",
                    border: "none",
                    borderRadius: 5,
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* --- Edit Modal Popup --- */}
      {isEditMode && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) handleClose();
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: 25,
              borderRadius: 10,
              width: "54vw",
              maxWidth: '70vw',
              boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
              animation: "fadeIn 0.3s ease-in-out",
              margin: '10px',
              height: '54vh',
              overflow: 'auto',
            }}
          >
            <h3 style={{ textAlign: "center", marginBottom: 15 }}>
              Edit Lead
            </h3>

            <form
              onSubmit={ handleUpdateLead }
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "12px 18px",
                overflow: 'auto'
              }}
            >

            

              {/* Row 3 */}
                <div style={{ gridColumn: "1 / span 2" }}>
                          <label>Enquiry Details shared by Caller:</label>
                          <textarea
                            rows={2}
                            placeholder="Write Caller's queries here"
                            value={formData.enquiryDetails || ""}
                            onChange={(e) =>
                              setFormData((p) => ({ ...p, enquiryDetails: e.target.value }))
                            }
                            required   // 🔑 Add this
                            style={{
                              ...inputStyleT,
                              resize: "vertical",
                              minHeight: "60px",
                              width: '45vw !important'
                            }}
                          />
                        </div>

              <div style={{ gridColumn: "1 / span 2" }}>
                <label>FollowUp Comments By MYC:</label>
                <textarea
                  rows={2}
                  value={formData.comments || ""}
                  placeholder="Answers to Caller's queries here"
                  onChange={(e) =>
                    setFormData((p) => ({ ...p, comments: e.target.value }))
                  }
                   required   // 🔑 Add this
                  style={{
                    ...inputStyleT,
                    resize: "vertical",
                    minHeight: "60px",
                    width: '45vw !important'
                  }}
                />
              </div>


              <div>
                <label>Follow-up Date:</label>
                <input
                  type="datetime-local"
                  value={
                    formData.followUpDate
                      ? new Date(formData.followUpDate).toISOString().slice(0, 16)
                      : ""
                  }
                  onChange={(e) =>
                    setFormData((p) => ({ ...p, followUpDate: e.target.value }))
                  }
                  style={inputStyle}
                />
              </div>

  {/* Row 2 */}
              <div>
                <label>Change Lead Status:</label>
                <select
                  value={formData.status}
                  onChange={(e) =>
                    setFormData((p) => ({ ...p, status: e.target.value }))
                  }
                  style={inputStyle}
                >
                  <option value="onhold">On Hold</option>
                  <option value="registered">Registered</option>
                  <option value="lost">Lost</option>
                </select>
              </div>

              {/* Buttons */}
              <div
                style={{
                  gridColumn: "1 / span 2",
                  display: "flex",
                  justifyContent: "center",
                  gap: 10,
                  marginTop: 8,
                }}
              >
                <button
                  type="submit"
                  style={{
                    background: "#007bff",
                    color: "white",
                    padding: "8px 18px",
                    border: "none",
                    borderRadius: 5,
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                 Update Lead
                </button>
                <button
                  type="button"
                  onClick={handleClose}
                  style={{
                    background: "#6c757d",
                    color: "white",
                    padding: "8px 18px",
                    border: "none",
                    borderRadius: 5,
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

    {/* 🗂️ Follow-up History Modal */}
    {isHistoryModalOpen && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0,0,0,0.4)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 3000,
        }}
        onClick={(e) => {
          if (e.target === e.currentTarget) closeHistoryModal();
        }}
      >
      <div
  style={{
    display: "flex",
    flexDirection: "column", // stack vertically
    alignItems: "center",    // center horizontally
    justifyContent: "center",// center vertically if needed
    gap: 20,                 // space between the two divs
    maxHeight: "90vh",      // full screen height
    overflow: 'auto',
    background: "#f5f5f5",   // light background for contrast
    padding: 20,
  }}
>
  {/* Follow-ups Section */}
  <div
    style={{
      background: "#fff",
      padding: 20,
      borderRadius: 10,
      width: "95%",
      maxWidth: "65vw",
      maxHeight: "70vh",
      overflowY: "auto",
      boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    }}
  >
    <h3 style={{ textAlign: "center", marginBottom: 15 }}>
      🗂️ Follow-ups
    </h3>

    {selectedLead?.followUpHistory?.length > 0 ? (
      <ul style={{ listStyle: "none", padding: 0 }}>
        {selectedLead.followUpHistory.map((entry, idx) => (
          <li
            key={idx}
            style={{
              padding: "8px 10px",
              borderBottom: "1px solid #ddd",
              marginBottom: 6,
            }}
          >
            <strong>Date:</strong>{" "}
            {new Date(entry.date || entry.followUpDate).toLocaleString()} <br /><br />
            <strong>Enquiry Details from Caller:</strong>{" "}
            {entry.enquiryDetails || "—"} <br /><br />
            <strong>Comments from MYC:</strong>{" "}
            {entry.comments || entry.notes || "—"}<br />
          </li>
        ))}
      </ul>
    ) : (
      <p style={{ textAlign: "center", color: "#666" }}>
        No follow-up history available.
      </p>
    )}

    <div style={{ textAlign: "center", marginTop: 15 }}>
      <button
        onClick={closeHistoryModal}
        style={{
          background: "#6c757d",
          color: "white",
          padding: "6px 14px",
          border: "none",
          borderRadius: 5,
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        Close
      </button>
    </div>
  </div>

  {/* WhatsApp Messages History Section */}
  <div
    style={{
      background: "#fff",
      padding: 20,
      borderRadius: 10,
      width: "95%",
      maxWidth: "65vw",
      maxHeight: "70vh",
      overflowY: "auto",
      boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    }}
  >
    <h3 style={{ textAlign: "center", marginBottom: 15 }}>
      🗂️ Whatsapp Messages History
    </h3>

    {selectedLead?.messageHistory?.length > 0 ? (
      <ul style={{ listStyle: "none", padding: 0 }}>
        {selectedLead.messageHistory.map((entry, idx) => (
          <li
            key={idx}
            style={{
              padding: "8px 10px",
              borderBottom: "1px solid #ddd",
              marginBottom: 6,
            }}
          >
            <strong>Date:</strong>{" "}
            {new Date(entry.date).toLocaleString()} <br /><br />
            <strong>Type:</strong>{" "}
            {entry.type || "—"} <br /><br />
            <strong>Text:</strong>{" "}
            {entry.text || "—"}<br />
          </li>
        ))}
      </ul>
    ) : (
      <p style={{ textAlign: "center", color: "#666" }}>
        No Whatsapp messages history available.
      </p>
    )}

    <div style={{ textAlign: "center", marginTop: 15 }}>
      <button
        onClick={closeHistoryModal}
        style={{
          background: "#6c757d",
          color: "white",
          padding: "6px 14px",
          border: "none",
          borderRadius: 5,
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        Close
      </button>
    </div>
  </div>
</div>

      </div>
    )}

    {isWhatsappModalOpen && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0,0,0,0.4)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 3000,
        }}
        onClick={(e) => {
          if (e.target === e.currentTarget) closeWhatsappModal();
        }}
      >
        <div
          style={{
            background: "#fff",
            padding: 20,
            borderRadius: 10,
            width: "90%",
            maxWidth: 500,
            maxHeight: "80vh",
            overflowY: "auto",
            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
          }}
        >
          <h3 style={{ textAlign: "center", marginBottom: 15 }}>
            🟢 WhatsApp Message for {selectedLead?.name}
          </h3>

          <label>Message Template:</label>
          <select
            value={formData.selectedTemplate || ""}
            onChange={(e) => {
              const templateId = e.target.value;
              const template = whatsappTemplates.find((t) => t.id === templateId);
              setFormData((p) => ({
                ...p,
                selectedTemplate: templateId,
                messageText: template
                  ? template.text.replace("{{name}}", selectedLead?.name || "there")
                  : "",
              }));
            }}
            style={{
              width: "100%",
              padding: 8,
              borderRadius: 4,
              border: "1px solid #ccc",
              marginBottom: 10,
            }}
          >
            <option value="">Select a Template</option>
            {whatsappTemplates.map((t) => (
              <option key={t.id} value={t.id}>
                {t.label}
              </option>
            ))}
          </select>

          <label>Message Text (Editable):</label>
          <textarea
            rows={5}
            value={formData.messageText || ""}
            onChange={(e) =>
              setFormData((p) => ({ ...p, messageText: e.target.value }))
            }
            placeholder="Type your message..."
            style={{
              width: "100%",
              border: "1px solid #ccc",
              borderRadius: 6,
              padding: 8,
              fontSize: 14,
              resize: "vertical",
              marginBottom: 10,
            }}
          />

          <div style={{ textAlign: "center", marginTop: 15 }}>
            <button
              type="button"
              onClick={handleSendWhatsApp}
              style={{
                marginTop: "8px",
                background: "#25D366",
                color: "white",
                padding: "6px 14px",
                border: "none",
                borderRadius: 5,
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              📲 Send & Record
            </button>

            <button
              onClick={closeWhatsappModal}
              style={{
                background: "#6c757d",
                color: "white",
                padding: "6px 14px",
                border: "none",
                borderRadius: 5,
                cursor: "pointer",
                fontWeight: "bold",
                marginLeft: 10,
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    )}

  </div>
)
};

// --- Styles ---
const inputStyle = {
  width: "5vw",
  padding: "6px 8px",
  borderRadius: 4,
  border: "1px solid #ccc",
  fontSize: "14px",
};

// --- Styles ---
const inputStyleT = {
  width: "15vw",
  padding: "6px 8px",
  borderRadius: 4,
  border: "1px solid #ccc",
  fontSize: "14px",
};

export default Callleads;
